import { Typography } from "@mui/material"

const Title = () => (
  <Typography variant="h1" gutterBottom>
    DCR user profile
  </Typography>
)

export { Title }
